var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartlySunnyIcon = function SvgPartlySunnyIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1982_16440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.95523 16.7809C5.13802 16.7525 5.30719 16.6672 5.43867 16.5371C5.57015 16.407 5.65723 16.2387 5.6875 16.0563C6.34867 12.0405 9.27664 9.625 12.6875 9.625C15.8555 9.625 17.9714 11.6895 18.8234 13.8764C18.8782 14.0166 18.9685 14.1401 19.0855 14.2347C19.2025 14.3294 19.3421 14.3919 19.4906 14.4162C22.225 14.8619 24.5 16.6879 24.5 19.8625C24.5 23.1109 21.8422 25.375 18.5937 25.375H5.79687C3.08984 25.375 0.875 24.0242 0.875 21.0437C0.875 18.393 2.98977 17.0942 4.95523 16.7809Z",
    stroke: "#E94E32",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0436 14.8422C21.5785 14.4297 22.0106 13.8989 22.3061 13.2914C22.6015 12.684 22.7523 12.0163 22.7466 11.3409C22.7409 10.6654 22.5788 10.0004 22.2732 9.39803C21.9675 8.79566 21.5265 8.27225 20.9847 7.86881C20.4429 7.46537 19.815 7.19287 19.1503 7.07266C18.4856 6.95244 17.8021 6.98778 17.1533 7.17591C16.5045 7.36403 15.9082 7.69983 15.4109 8.15699C14.9136 8.61415 14.5289 9.18025 14.287 9.81094M25.3748 11.375H27.1248M18.3748 2.625V4.375M12.1875 5.18766L13.4251 6.42523M24.5622 5.18766L23.3246 6.42523",
    stroke: "#E94E32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1982_16440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartlySunnyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "partly-sunny-icon.e9f3df882ba33a541e55552d9005357b.svg";